import classNames from 'classnames'

import styles from '../styles/footer.module.scss'

const FooterListHeader = ({ header }) => <li className={classNames(styles.footerListHeader, 'text-large')}>{header}</li>

FooterListHeader.propTypes = {
    header: PropTypes.string,
}

export default FooterListHeader
